/* eslint-disable react-hooks/exhaustive-deps */

import { useState } from "react";
import { useAuth } from "context/AuthContext";
import {
  Header,
  ListRanking,
  BannerPodiumPreview,
  BannerPodiumTreasure,
} from "components";
import { useHomeRanking } from "hooks/ranking/useHomeRanking";

import "./styles.scss";
import { Helmet } from "react-helmet-async";

export function Preview() {
  const { user } = useAuth();
  const [searchQuery, setSearchQuery] = useState("");

  // Buscar dados reais da API
  const { topPlayers, allPlayers, isLoading, error } = useHomeRanking();

  // Filtrar jogadores pela busca
  const filteredPlayers = allPlayers.filter(
    (player) =>
      player.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      player.teamName?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };

  return (
    <>
      <Helmet>
        <title>Dashboard - Rankifier</title>
      </Helmet>
      <div className="home-wrapper-preview">
        <Header />
        <div className="home-content">
          <div className="z-10 relative flex flex-col items-center w-full h-full">
            <div className="w-full h-full" id="homeLogin">
              {user ? (
                <div className="rankings-container">
                  {/* Exibir erro se houver */}
                  {error && !isLoading && (
                    <div className="error-message">
                      <p>⚠️ {error}</p>
                      <p className="error-subtitle">
                        Entre em contato com o administrador
                      </p>
                    </div>
                  )}

                  {/* Layout lado a lado: Top 3 (70%) + Ranking Completo (30%) */}
                  {!error && (
                    <div className="rankings-side-by-side">
                      {/* Top 3 - Preview com Imagens */}
                      <div className="ranking-left">
                        <BannerPodiumPreview
                          title="Top 3"
                          players={topPlayers}
                          isLoading={isLoading}
                        />
                      </div>

                      {/* Ranking Completo (30%) */}
                      <div className="ranking-right">
                        {isLoading ? (
                          <div className="ranking-loading">
                            <div className="spinner"></div>
                            <p>Carregando ranking...</p>
                          </div>
                        ) : (
                          <ListRanking
                            players={filteredPlayers}
                            currentUserId={user._id || user.email || ""}
                            title="Ranking Completo"
                          />
                        )}
                      </div>
                    </div>
                  )}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
